namespace $ { export class $piterjs_others_event extends $mol_link_iconed {

	/**
	 *  ```
	 *  start $mol_time_moment
	 *  ```
	 **/
	@ $mol_mem
	start() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_time_moment(  ) )
	}

	/**
	 *  ```
	 *  target \_blank
	 *  ```
	 **/
	target() {
		return "_blank"
	}

	/**
	 *  ```
	 *  content /
	 *  	<= Location
	 *  	<= Date
	 *  	<= Title
	 *  ```
	 **/
	content() {
		return [this.Location() , this.Date() , this.Title()] as readonly any[]
	}

	/**
	 *  ```
	 *  Location $mol_paragraph sub / <= location
	 *  ```
	 **/
	@ $mol_mem
	Location() {
		return (( obj )=>{
			obj.sub = () => [this.location()] as readonly any[]
			return obj
		})( new this.$.$mol_paragraph(  ) )
	}

	/**
	 *  ```
	 *  location \
	 *  ```
	 **/
	location() {
		return ""
	}

	/**
	 *  ```
	 *  Date $mol_paragraph sub / <= date
	 *  ```
	 **/
	@ $mol_mem
	Date() {
		return (( obj )=>{
			obj.sub = () => [this.date()] as readonly any[]
			return obj
		})( new this.$.$mol_paragraph(  ) )
	}

	/**
	 *  ```
	 *  date \
	 *  ```
	 **/
	date() {
		return ""
	}

	/**
	 *  ```
	 *  Title $mol_paragraph sub / <= title
	 *  ```
	 **/
	@ $mol_mem
	Title() {
		return (( obj )=>{
			obj.sub = () => [this.title()] as readonly any[]
			return obj
		})( new this.$.$mol_paragraph(  ) )
	}

	/**
	 *  ```
	 *  title \
	 *  ```
	 **/
	title() {
		return ""
	}

} }
